export const menuData = [
  {
    label: 'Product',
    value: '1',
    icon: '',
    // unfold: false,
    href: '',
    children: [
      {
        value: '1-1',
        label: 'Travel Insurance',
        icon: 'travel',
        children: [
          {
            value: '1-1-1',
            label: 'Travel Smart',
            // icon: true,,
            href: '/en/Travel-Smart/Application',
          },
          {
            value: '1-1-2',
            label: 'SmartGo GBA Travel Insurance',
            // icon: true,,
            href: '/en/GBATravel/Information',
          },
          {
            value: '1-1-3',
            label: 'Working HolidaySafe',
            // icon: true,,
            href: '/en/Working-Holiday/Information',
          },
          {
            value: '1-1-4',
            label: ' Inbound Travel Insurance - Premier Plan',
            // icon: false,,
            href: '/en/inbound-travel/Information',
          },
          {
            value: '1-1-5',
            label: 'Overseas StudySafe Insurance',
            // icon: true,,
            href: '/en/Overseas-StudySafe/Information',
          },
        ],
        // onLine: {
        //   label: 'Online Enrolment Available',
        // },
      },
      {
        value: '1-2',
        label: 'General Insurance',
        icon: 'owner',
        children: [
          {
            value: '1-2-1',
            label: 'HomeSafe Protection Insurance',
            // icon: true,,
            href: '/en/HomeSafe-Protection-Insurance/Information',
          },
          {
            value: '1-2-2',
            label: 'SmartPro Drive Insurance ',
            // icon: true,,
            href: '/en/smartProDrive/Information',
            tag: 'New',
          },
          {
            value: '1-2-3',
            label: 'MaidSafe Insurance',
            // icon: true,,
            href: '/en/MaidSafe-Insurance/Information',
          },
          {
            value: '1-2-4',
            label: 'SmartFit Sports Insurance',
            // icon: true,,
            href: '/en/SmartFit/Information',
          },

          {
            value: '1-2-5',
            label: ' DecorationSafe Insurance ',
            // icon: true,,
            href: '/en/Decoration-Insurance/Information',
            tag: 'New',
          },
          {
            value: '1-2-6',
            label: 'Personal Accident Insurance',
            // icon: true,,
            href: '/en/Personal-Accident-Insurance/Information',
          },
          {
            value: '1-2-7',
            label: 'LovePet Insurance',
            // icon: true,,
            href: '/en/lovepet/Information',
          },
          {
            value: '1-2-8',
            label: 'Personal AccidentSafe Insurance',
            // icon: false,,
            href: '/en/personal-accidentsafe/Information',
          },
          {
            value: '1-2-9',
            label: 'LovePet Outpatient Insurance',
            // icon: true,,
            href: '/en/LovePet-Outpatient-Insurance/Information',
          },
          {
            value: '1-2-10',
            label: 'Fire Insurance',
            // icon: false,,
            href: '/en/fire-insurance/Information',
          },
          {
            value: '1-2-11',
            label: 'Taipan GolferSafe',
            // icon: true,,
            href: '/en/taipan-golfersafe/Information',
          },
          {
            value: '1-2-12',
            label: "Employees' Compensation Insurance",
            // icon: false,,
            href: '/en/employees-compensation-insurance/Information',
          },
          {
            value: '1-2-13',
            label: 'GolferSafe',
            // icon: true,,
            href: '/en/golfersafe/Information',
          },
        ],
        // onLine: {
        //   label: 'Online Enrolment Available',
        // },
      },
      {
        value: '1-3',
        label: 'Business Insurance',
        icon: 'suitcase',
        children: [
          {
            value: '1-3-1',
            label: 'BusinessSafe Insurance',
            full: true,
            href: '/en/businesssafe-insurance/Information',
          },
        ],
      },
      {
        value: '1-4',
        type: 'right',
        label: 'Individual Medical Insurance',
        icon: 'heart',
        children: [
          {
            value: '1-4-1-1',
            label: 'Blue Cross Love Yourself VHIS Plan ',
            // icon: true,,
            tag: 'New',
            href: '/en/VHIS/love-yourself-vhis/information',
          },
          {
            value: '1-4-2',
            label: 'Tycoon Medical Insurance Plan',
            // icon: false,,
            href: '/en/tycoon-medical-insurance-plan/Information',
          },
          {
            value: '1-4-1',
            label: 'Blue Cross Dynasty VHIS Plan',
            // icon: true,,
            href: '/en/Dynasty-VHIS/Information',
          },
          {
            value: '1-4-4',
            label: 'Caring Medical Protection Plus',
            // icon: true,,
            href: '/en/caring-medical-protection-plus/Application',
          },
          {
            value: '1-4-3',
            label: 'CareForYou Super Flexi Plan for VHIS',
            // icon: true,,
            href: '/en/CareForYou-VHIS-Super-Flexi/Information',
          },
          {
            value: '1-4-6',
            label: 'CareForYou Flexi Plan for VHIS',
            des: '(Not available for new application)',
            // icon: false,,
            href: '/en/CareForYou-VHIS-Flexi/Information',
          },
          {
            value: '1-4-5',
            label: 'CareForYou Standard Plan for VHIS',
            // icon: true,,
            href: '/en/CareForYou-VHIS-Standard/Information',
          },

          {
            value: '1-4-7',
            label: 'Job Changer Medical Protection',
            // icon: true,,
            full: true,
            href: '/en/Job-Changer-Medical-Protection/Information',
          },
          {
            value: '1-4-8',
            label: 'All-in-one Outpatient Insurance',
            // icon: true,,
            full: true,
            href: '/en/all-in-one-outpatient-insurance/Information',
          },
          {
            value: '1-4-9',
            label: 'Dental Plan',
            // icon: true,,
            full: true,
            href: '/en/dental-plan/Information',
          },
        ],
        // onLine: {
        //   label: 'Online Enrolment Available',
        // },
      },

      {
        value: '1-5',
        type: 'right',
        label: 'Group Medical Insurance',
        icon: 'heart',
        children: [
          {
            value: '1-5-1',
            full: true,
            label:
              'Employee Medical Care Plan (formerly known as &quot;Employees Medical Contract&quot;)',
            href: '/en/employee-medical-care-plan/Information',
          },
          {
            value: '1-5-2',
            label: 'Blue Cross Employee Critical Illness Care Plan ',
            tag: 'New',
            full: true,
            href: '/en/employee-critical-illness-care-plan/Information',
          },
        ],
      },
      {
        value: '1-6',
        type: 'right',
        label: 'Health Check',
        icon: 'note',
        children: [
          {
            value: '1-6-1',
            label: 'Cancer Screening Programme',
            full: true,
            href: '/en/cancer-screening/Information',
          },
          {
            value: '1-6-2',
            label: 'Preventive Checkup and Immunisation Programme',
            full: true,
            href: '/en/preventive-checkup-immunisation/Information',
          },
          {
            value: '1-6-3',
            label: 'U Care Medical Checkup Scheme',
            full: true,
            href: '/en/u-care-medical-checkup/Information',
          },
        ],
      },
    ],
  },
  {
    label: 'Service',
    value: '2',
    children: [
      {
        value: '2-1',
        label: 'Policy Service',
        icon: 'travel',
        foldState: false,
        children: [
          {
            value: '2-1-1',
            label: 'Renewal',
            // icon: false,,
            full: true,
            href: '/renewal/en/home',
          },
          {
            value: '2-1-2',
            label: 'Premium Payment Exchange Rate',
            // icon: false,,
            full: true,
            href: '/en/Exchange-Rates/Information',
          },
          {
            value: '2-1-3',
            label: 'VHIS Conversion ',
            // icon: false,,
            full: true,
            tag: 'New',
            href: '/en/VHIS-Migration/Application',
          },
          {
            value: '2-1-4',
            label: 'Change of Particulars',
            // icon: false,,
            full: true,
            href: '/en/OnlineEndorse/Home',
          },
        ],
      },
      {
        value: '2-2',
        label: 'Download Files',
        icon: 'file',
        foldState: true,
        lock: true,
        children: [
          {
            value: '2-2-1',
            full: true,
            label:
              'Insurance-related forms and documents, including application forms, product brochures, terms and conditions, and more',
            href: '/en/downloads/Others',
          },
        ],
      },
      {
        value: '2-3',
        label: 'Useful Links',
        icon: 'heart',
        type: 'right',
        children: [
          {
            value: '2-3-1',
            full: true,
            label: 'List of Panel Hospitals',
            href: '/en/hospitals-list/Information',
          }, 
          {
            value: '2-3-2',
            full: true,
            label: 'Nil Depreciation Repairers Network',
            href: '/en/motor-insurance/NilDepreciationOnRepairs',
          },
          {
            value: '2-3-3',
            full: true,
            label: 'Windscreen Repairers Network',
            href: '/ch/motor-insurance/WindscreenRepairesNetwork',
          },
          {
            value: '2-3-4',
            full: true,
            label: ' 24-Hour Emergency Roadside Assistance',
            href: '/ch/motor-insurance/ServiceHotlineWindscreenRepairesNetwork',
          },

          {
            value: '2-3-5',
            full: true,
            label: 'Contact Us',
            href: '',
          },
        ],
      },
    ],
  },
  {
    label: 'Claims',
    value: '3',
    // type: 'single',
    children: [
      {
        value: '3-1',
        label: 'Claim Services',
        icon: 'travel',
        foldState: true,
        children: [
          {
            value: '3-1-1',
            // icon: false,,
            label: 'Travel Insurance',
            href: '/online-eclaim/en/travel-claim',
          },
          {
            value: '3-1-2',
            // icon: false,,
            label: 'Domestic Helper Insurance',
            href: '/online-eclaim/en/maid-claim',
          },
          {
            value: '3-1-3',
            icon: '',
            label: 'Pet Insurance',
            href: '/online-eclaim/en/pet-claim',
          },
          {
            value: '3-1-4',
            // icon: false,,
            label: 'Other General Insurance',
            href: '/en/Online-Claim-GI/Submission',
          },
          {
            value: '3-1-5',
            // icon: false,,
            label: 'Motor Insurance',
            href: '/en/Online-Claim-Motor/Submission',
          },
          {
            value: '3-1-6',
            // icon: false,,
            label: 'Home Insurance',
            href: '/en/Online-Claim-HomeSafe/Submission',
          },
        ],
      },
      {
        value: '3-2',
        label: 'Claim Forms Download',
        icon: 'file',
        foldState: false,
        type: 'right',
        children: [
          // {
          //   value: '3-2-1',
          //   // icon: false,,
          //   label: 'Super Care',
          //   type: 'single',
          //   href: 'https://supercare.bluecross.com.hk/Member/MemberDefault.aspx?CurrentLang=chi',
          // },
          {
            value: '3-2-2',
            // icon: false,,
            label: 'Claim Procedures & Claim Forms',
            // type: 'single',
            href: '/en/downloads/Claims-Form-Procedure',
          },
        ],
      },
    ],
  },
  {
    value: '4',
    icon: '',
    label: 'Blog',
    target: '_blank',
    href: '/Blog',
  },
];

export const loginMenu = {
  indexText: 'Home',
  label: 'Login',
  value: '1',
  // unfold: true,
  href: '/en/Home/Index',
  children: [
    {
      value: '1-1',
      label: 'Customer Portal',
      href: '/en/welcome/Information',
      target: '_self',
      className: 'iron-header-loginPop-blueItem',
      id: 'home_cpLogin',
    },
    {
      value: '1-2',
      label: 'SmartClub',
      href: '/en/SmartClub/Index',
      target: '_self',
      logout: true,
      className: 'iron-header-loginPop-blueItem',
      id: 'home_clubLogin',
    },
    {
      value: '1-3',
      label: 'Super Care',
      href: 'https://supercare.bluecross.com.hk/Member/MemberDefault.aspx?CurrentLang=eng',
      target: '_blank',
      className: 'iron-header-loginPop-blueItem',
      disabledDefaultA: true,
      id: 'home_superCareLogin',
    },

    // {
    //   value: '1-3',
    //   // icon: false,,
    //   label: 'Super Agent',
    //   href: 'https://superagent.bluecross.com.hk/superagent/',
    //   target: '_blank',
    // },
  ],
};

export const superCareInfo = {
  label: 'Super Care',
  target: '_blank',
  href: 'https://supercare.bluecross.com.hk/Member/MemberDefault.aspx?CurrentLang=eng',
};


export const headerTabs =  [
  {
    href: '/ch/Home/Index',
    label:'Individual',
    value:1,
    active:true,
  },
  {
    href: '/ch/Commercial/Information',
    label:'Business',
    value:2,
  }
];